<template>
  <div class="section-block">
    <div v-if="title" class="sb-title">{{ title }}</div>
    <div v-if="parsedItems.length > 0" class="sb-list">
      <div v-for="(item, idx) in parsedItems" :key="idx" class="sb-item">
        <span class="sb-dot">·</span>
        <span class="sb-text">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionBlock',
  props: {
    title: { type: String, default: '' },
    items: { type: [Array, String], default: () => [] }
  },
  computed: {
    parsedItems() {
      if (Array.isArray(this.items)) return this.items
      if (typeof this.items === 'string') {
        try {
          const parsed = JSON.parse(this.items)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.section-block {
  max-width: 800px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e8eaee;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.sb-title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.6;
  margin-bottom: 8px;
}

.sb-item {
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  color: #4b5563;
  line-height: 1.75;
}

.sb-dot {
  flex-shrink: 0;
  margin-right: 6px;
  color: #9ca3af;
}

.sb-text {
  flex: 1;
  word-break: break-word;
}
</style>
